var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-aside"},[_vm._v(" 这是Page1页面 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }